export const ALL_EMAIL_TYPES = "all";

export const formatEmailType = (value?: string | null): string => {
  if (!value) return "";
  return value.replace(/_/g, " ").replace(/\b\w/g, char => char.toUpperCase());
};

/** Normalize tracking vs preview keys (e.g. weekly_digest ↔ weekly_digest_email). */
export const normalizeEmailTypeKey = (value?: string | null): string => {
  if (!value) return "";
  const normalized = value.trim().toLowerCase();
  return normalized.endsWith("_email")
    ? normalized.slice(0, -"_email".length)
    : normalized;
};

export const buildEmailTypeOptions = (
  emailTypes: string[]
): { label: string; value: string }[] => {
  const uniqueTypes = Array.from(new Set(emailTypes.filter(Boolean))).sort(
    (a, b) => formatEmailType(a).localeCompare(formatEmailType(b))
  );

  return [
    { label: "All Email Types", value: ALL_EMAIL_TYPES },
    ...uniqueTypes.map(type => ({
      label: formatEmailType(type),
      value: type,
    })),
  ];
};

export const findEmailTemplateByType = <T extends { email_type: string }>(
  templates: T[],
  emailType?: string | null
): T | null => {
  if (!emailType || templates.length === 0) return null;

  const exact = templates.find(t => t.email_type === emailType);
  if (exact) return exact;

  const normalizedTarget = normalizeEmailTypeKey(emailType);
  return (
    templates.find(
      t => normalizeEmailTypeKey(t.email_type) === normalizedTarget
    ) ?? null
  );
};
